import eq from "lodash-es/eq"
import find from "lodash-es/find"
import isEmpty from "lodash-es/isEmpty"
import { shallowEqual, useSelector } from "react-redux"

import type { IRootState } from "../store"

import { EModalId, type IModal, MODAL_REDUCER_NAME, type TModalProps } from "./modal.slice"

type _TSelector<TProps extends TModalProps = {}> = (state: IRootState) => IModal<TProps>

function _selector<TProps extends TModalProps = {}>(id: EModalId): _TSelector<TProps> {
    return (state: IRootState): IModal<TProps> | undefined =>
        find(state[MODAL_REDUCER_NAME].modals, (modal: IModal<TProps>): boolean => eq(modal.id, id))
}

function useModalSelector<TProps extends TModalProps = {}>(id: EModalId): IModal<TProps> {
    return useSelector(_selector(id), shallowEqual)
}

function useAnyModalVisible(): boolean {
    return useSelector((state: IRootState): boolean => !isEmpty(state[MODAL_REDUCER_NAME].modals))
}

export { useModalSelector, useAnyModalVisible }
